













































































































































































import AfterFetchComponent from "@/components/base/AfterFetchComponent";
import {StoreNamespace} from "@/globals/StoreNamespaceGlobal";
import {MemberCRMDetails} from "@/store/modules/customerService";
import Component from 'vue-class-component'
import {Prop} from "vue-property-decorator";
import {Action} from "vuex-class";

@Component({
  components: {}
})
export default class MemberGeneralDetails extends AfterFetchComponent {

  @Prop() memberGeneralDetails!: MemberCRMDetails
  @Prop() restrictions!: string[]

  @Action('updatePersonalDetails', StoreNamespace.CUSTOMER_SERVICE) updatePersonalDetails: any


  private showEditMemberPhoneNumberOrEmailModal: boolean = false
  private mobilePhoneNumber: string = ""
  private emailAddress: string = ""

  mounted() {
    this.mobilePhoneNumber = this.memberGeneralDetails.mobilePhoneNumber
    this.emailAddress = this.memberGeneralDetails.email
  }


  onSuccess(data?: any, requestName?: string, message?: string) {
    switch (requestName) {
      case 'findMembersOrEmployersFor/updatePersonalDetails':
        this.showEditMemberPhoneNumberOrEmailModal = false
        const isMember = true;
        this.$emit('afterSuccessPersonalDetailsUpdate', isMember)
    }
  }


  editMemberPhoneNumberOrEmail() {
    this.showEditMemberPhoneNumberOrEmailModal = true
  }

  onHideModal() {
    this.showEditMemberPhoneNumberOrEmailModal = false
  }

  onSaveNewPhoneNumberAndEmailAddress() {
    this.updatePersonalDetails({
      requestorCallback: this,
      requestBody: {
        isMember: true,
        memberIdNumber: this.memberGeneralDetails.personalId,
        mobilePhoneNumber: this.mobilePhoneNumber,
        emailAddress: this.emailAddress
      }
    })
  }

}
